// extracted by css-extract-rspack-plugin
export default {"root":"oyfQTo","align-items-center":"diuHOu","alignItemsCenter":"diuHOu"};